<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 15px 0;">
		<b-container class="bv-example-row">
			<img class="bannerPay" src="@/assets/images/bannerPay.png" />
			<b-form @submit="onSubmit" @reset="onReset" v-if="show">
				<div class="mini-title">商品信息</div>
				<div class="label-name">
					<b-form-group id="input-group-1" label="购买培训课程:" label-for="input-1" label-cols-sm="2"
						label-align-sm="right">
						<b-form-select @change="changeLesson" id="input-1" v-model="form.productId"
							:options="lessonOption" required></b-form-select>
					</b-form-group>
				</div>
				<b-form-group id="input-group-2" label="价格:" label-for="input-2" label-cols-sm="2"
					label-align-sm="right">
					<b-form-input :disabled="true" id="input-2" v-model="price"></b-form-input>
				</b-form-group>
				<div class="label-name">
					<b-form-group id="input-group-3" label="购买数量:" label-for="input-3" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-3" v-model="form.productCount" type='number' placeholder="请输入购买数量"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group id="input-group-4" label="手机号码:" label-for="input-4" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-4" type='tel' v-model="form.productPhone" placeholder="请输入手机号码"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group description="验证码5分钟内有效" id="input-group-5" label="手机验证码:" label-for="input-5"
						label-cols-sm="2" label-align-sm="right">
						<b-form-input id="input-5" v-model="form.authCode" type='tel' placeholder="请输入手机验证码"
							required></b-form-input>
						<el-button size="mini" type="success" @click.native.prevent="bindforgetSendCode"
							class="bind_code_gain" :disabled="disabled">{{ btnText }}</el-button>
					</b-form-group>
				</div>
				<b-form-group id="input-group-6" label="支付方式:" v-slot="{ ariaDescribedby }" label-for="input-6"
					label-cols-sm="2" label-align-sm="right">
					<b-form-radio style="margin-top: 5px;" id="input-6" v-model="form.productPayMethod"
						:aria-describedby="ariaDescribedby" name="some-radios" value="微信">微信支付</b-form-radio>
				</b-form-group>
				<div class="mini-title">发票信息</div>
				<div class="label-name">
					<b-form-group id="input-group-7" label="发票类型:" label-for="input-7" label-cols-sm="2"
						label-align-sm="right">
						<b-form-select @change="changeInvoice" id="input-7" v-model="form.invoiceType"
							:options="fplxOption" required></b-form-select>
					</b-form-group>
				</div>
				<div v-show="form.invoiceType != 2">
					<b-form-group id="input-group-8" label=" 抬头类型:" label-for="input-8" label-cols-sm="2"
						label-align-sm="right">
						<b-form-select id="input-8" v-model="form.invoiceTtType" :options="ttlxOption"></b-form-select>
					</b-form-group>
					<b-form-group id="input-group-9" label="发票内容:" label-for="input-9" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-9" v-model="form.invoiceContent" disabled></b-form-input>
					</b-form-group>
					<b-form-group id="input-group-10" label="发票金额:" label-for="input-10" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input :disabled="true" id="input-10" v-model="allPrice"></b-form-input>
					</b-form-group>
					<b-form-group id="input-group-11" label="发票抬头:" label-for="input-11" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-11" v-model="form.invoiceTt" placeholder="请输入发票抬头"></b-form-input>
					</b-form-group>
					<b-form-group id="input-group-12" label="税号:" label-for="input-12" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-12" v-model="form.invoiceSh" placeholder="请输入税号"></b-form-input>
					</b-form-group>
					<!-- <b-form-group id="input-group-15" label="开户银行:" label-for="input-15" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-15" v-model="form.invoiceBank" placeholder="请输入开户银行"></b-form-input>
					</b-form-group>
					<b-form-group id="input-group-16" label="开户账户:" label-for="input-16" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-16" v-model="form.invoiceAccount" placeholder="请输入开户账户"></b-form-input>
					</b-form-group>
					<b-form-group id="input-group-17" label="单位地址:" label-for="input-17" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-17" v-model="form.invoiceAddress" placeholder="请输入单位地址"></b-form-input>
					</b-form-group> -->
				</div>
				<div class="mini-title">配送信息</div>
				<div class="label-name">
					<b-form-group id="input-group-13" label="收件人:" label-for="input-13" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-13" v-model="form.dispatchReceiver" placeholder="请输入收件人"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group id="input-group-14" label="邮箱:" label-for="input-14" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-14" v-model="form.dispatchEmail" type="email" placeholder="请输入邮箱"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="bottom-money">
					<div>总价：<span style="color: #F34343;">￥{{allPrice}}</span></div>
					<div>
						<b-button type="submit" variant="primary">立即支付</b-button>
					</div>
				</div>
			</b-form>
		</b-container>
	</div>
</template>

<script>
	import {
		lessonList,
		native
	} from "@/api/lesson";
	import {
		getDicts,
		getCodeSms
	} from "@/api/login";
	import tencentCaptchaMixin from '@/mixins/tencentCaptcha'
	
	export default {
		mixins: [tencentCaptchaMixin],
		data() {
			return {
				lessonOption: [{
					text: '请选择',
					value: null
				}],
				ttlxOption: [{
					text: '请选择',
					value: null
				}],
				fplxOption: [{
					text: '请选择',
					value: null
				}],
				lessonList: [],
				show: true,
				price: '0.00',
				form: {
					productId: null,
					productCount: 0,
					productPhone: null,
					authCode: null,
					productPayMethod: '微信',
					invoiceType: null,
					invoiceTt: null,
					invoiceTtType: null,
					invoiceContent: '培训费',
					invoiceSh: null,
					invoiceBank: null,
					invoiceAccount: null,
					invoiceAddress: null,
					dispatchReceiver: null,
					dispatchEmail: null
				},
				btnText: "获取验证码",
				disabled: false
			}
		},
		mounted() {
			this.lessonOption = [{
				text: '请选择',
				value: null
			}]
			//抬头类型
			getDicts('ttlx').then(res => {
				res.data.forEach(item => {
					this.ttlxOption.push({
						text: item.dictLabel,
						value: item.dictValue
					})
				})
			})
			//发票类型
			getDicts('fplx').then(res => {
				res.data.forEach(item => {
					this.fplxOption.push({
						text: item.dictLabel,
						value: item.dictValue
					})
				})
			})
			lessonList().then(res => {
				this.lessonList = res.rows
				res.rows.forEach(item => {
					this.lessonOption.push({
						text: item.title,
						value: item.baseId
					})
				})
			})
		},
		computed: {
			allPrice() {
				return parseFloat(this.price) * this.form.productCount
			}
		},
		methods: {
			changeInvoice(e) {
				console.log("e: ", e);
			},
			
			// 发送验证码
			bindforgetSendCode() {
				event.preventDefault()
				// 使用 mixin 提供的方法发送短信验证码
				this.sendSmsCodeWithCaptcha(this.form.productPhone, (uuid) => {
					// 保存 uuid
					this.form.authId = uuid;
					this.disabled = true;
					this.btnText = "请稍候...";
					setTimeout(() => {
						this.doLoop(60);
					}, 500);
				});
			},
			// 手机验证码的倒计时
			doLoop: function(seconds) {
				seconds = seconds ? seconds : 60;
				this.btnText = seconds + "s后获取";
				// this.code = code
				let countdown = setInterval(() => {
					if (seconds > 0) {
						this.btnText = seconds + "s后获取";
						--seconds;
					} else {
						this.btnText = "获取验证码";
						this.disabled = false;
						clearInterval(countdown);
					}
				}, 1000);
			},
			//选中课程
			changeLesson(e, all) {
				this.price = this.lessonList.find(item => item.baseId == e).sellPrice
			},
			onSubmit(event) {
				event.preventDefault()
				var reg = /^1[0-9]{10}$/
				if (!reg.test(this.form.productPhone)) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入正确的手机号！'
					})
				} else {
					native(this.form).then(res => {
						if (res.code == 200) {
							this.$router.push({
								path: "/payCode",
								query: {
									code: res.data.codeUrl,
									price: parseFloat(this.price) * this.form.productCount,
									orderNo: res.data.orderNo
								}
							})
						} else {
							this.$message({
								showClose: true,
								type: 'error',
								message: res.msg
							})
						}
					})
				}
			},
			onReset(event) {
				event.preventDefault()
				this.form = {
					productId: null,
					productCount: 0,
					productPhone: null,
					authCode: null,
					productPayMethod: '微信',
					invoiceType: null,
					invoiceTt: null,
					invoiceTtType: null,
					invoiceContent: '培训费',
					invoiceSh: null,
					invoiceBank: null,
					invoiceAccount: null,
					invoiceAddress: null,
					dispatchReceiver: null,
					dispatchEmail: null
				}
				this.price = "0.00"
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.label-name {
		position: relative;
	}

	.bind_code_gain {
		position: absolute;
		top: 5px;
		right: 10px;
	}

	.bannerPay {
		width: 100%;
		height: 230px;
		display: block;
	}

	@media screen and (max-width: 997px) {
		.bannerPay {
			height: 150px;
		}

		.bottom-money {
			padding: 15px !important;
		}
	}

	.mini-title {
		padding-left: 15px;
		position: relative;
		margin: 20px 0;
		font-weight: 600;
	}

	.mini-title::after {
		content: "";
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
		width: 5px;
		height: 20px;
		background-color: #007BFF;
		border-radius: 5px;
	}

	.bottom-money {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #F5F7FA;
		padding: 30px;
	}
</style>